(function () {
    angular.module('tradersyard').directive('graphReport', GraphReportDirective);

    GraphReportDirective.$inject = ['$rootScope', 'graph-report-service'];

    function GraphReportDirective($rootScope, reportService) {
        return {
            restrict: 'A',
            scope: {
                entryName: '=graphReportEntryName',
                entryModel: '=graphReportEntryModel',
                entryId: '=graphReportEntryId',
            },
            link: function ($scope, $element) {
                $element.bind('click', function () {
                    if (!$rootScope.me) {
                        return;
                    }
                    reportService.reportAnything($scope.entryName, $scope.entryModel, $scope.entryId);
                });
            },
        };
    }
})();
